import React from "react";

const AssessmentIcon = ({ className = "madie-icon", ...props }) => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.43671 7C1.89984 7.98526 2.72341 9.34503 3.8132 10.4869C5.01406 11.7451 6.44558 12.6452 8 12.6452C9.55442 12.6452 10.9859 11.7451 12.1868 10.4869C13.2766 9.34503 14.1002 7.98526 14.5633 7C14.1002 6.01474 13.2766 4.65497 12.1868 3.51311C10.9859 2.25488 9.55442 1.35484 8 1.35484C6.44558 1.35484 5.01406 2.25488 3.8132 3.51311C2.72341 4.65497 1.89984 6.01474 1.43671 7ZM2.81537 2.58367C4.1288 1.20749 5.89728 0 8 0C10.1027 0 11.8712 1.20749 13.1846 2.58367C14.5069 3.96912 15.462 5.62076 15.9446 6.73315C16.0185 6.90356 16.0185 7.09644 15.9446 7.26685C15.462 8.37924 14.5069 10.0309 13.1846 11.4163C11.8712 12.7925 10.1027 14 8 14C5.89728 14 4.1288 12.7925 2.81537 11.4163C1.49309 10.0309 0.538021 8.37924 0.0554434 7.26685C-0.0184811 7.09644 -0.0184811 6.90356 0.0554434 6.73315C0.538021 5.62076 1.49309 3.96912 2.81537 2.58367Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 9.53327C8.72353 9.53327 9.65 8.78261 9.65 7.40927C9.65 6.03594 8.72353 5.28528 8 5.28528C7.27647 5.28528 6.35 6.03594 6.35 7.40927C6.35 8.78261 7.27647 9.53327 8 9.53327ZM8 10.8669C9.65685 10.8669 11 9.31889 11 7.40927C11 5.49966 9.65685 3.95161 8 3.95161C6.34315 3.95161 5 5.49966 5 7.40927C5 9.31889 6.34315 10.8669 8 10.8669Z"
      />
    </svg>
  );
};

export default AssessmentIcon;
